/* eslint-disable import/prefer-default-export */
import { hasAdminMembership } from './user';

export const isFeatureFlagEnabled = (flag, user = null) => {
  try {
    const value = JSON.parse(localStorage.getItem(flag));
    const localEnabled = value === 1;
    if (!localEnabled) return false;
    // If a user is provided, require admin membership
    if (user !== null) return hasAdminMembership(user);
    // No user context available (e.g. module init) — fall back to localStorage only
    return true;
  } catch (e) {
    return false;
  }
};

export const updateRecentPackages = (listingID, packageID) => {
  let storedPackages = JSON.parse(localStorage.getItem('RecentPackages')) || [];

  const packages = `${listingID}:${packageID}`;

  // Remove the package if it already exists in the array
  const existingIndex = storedPackages.indexOf(packages);
  if (existingIndex !== -1) {
    storedPackages.splice(existingIndex, 1);
  }

  // Add the new packages to the beginning of the array
  storedPackages.unshift(packages);

  // Only keep the last 6 packages
  if (storedPackages.length > 6) {
    storedPackages = storedPackages.slice(0, 6);
  }

  localStorage.setItem('RecentPackages', JSON.stringify(storedPackages));
};
